import React, { useState, useEffect } from 'react';

import { Row, Col } from 'react-bootstrap';
import SkyPulseTable from 'components/SkyPulseTable';
import UsageFilter from '../UsageFilter';
import { getUTCShortDate } from 'utils';
import { WeekOptions, defaultUsageFilters } from 'constants';

import styles from './styles.module.css';

const columnDefinitions = [
  {
    name: 'Rank',
    key: 'rank',
    size: 'xsmall',
    sortable: true,
    dataCyClassName: 'Usage-LiveTVTableColumn-rank',
  },
  {
    name: 'Channel',
    key: 'channel',
    size: 'small',
    sortable: true,
    dataCyClassName: 'Usage-LiveTVTableColumn-channel',
  },
  {
    name: 'Passengers',
    key: 'passengers',
    size: 'xsmall',
    sortable: true,
    dataCyClassName: 'Usage-LiveTVTableColumn-passengers',
  },
  {
    name: 'Passenger pool %',
    key: 'passenger_pool_per',
    size: 'small',
    sortable: true,
    dataCyClassName: 'Usage-LiveTVTableColumn-passengerPoolPer',
  },
  {
    name: 'Total view minutes',
    key: 'total_views_minutes',
    size: 'small',
    className: styles.colWidth,
    sortable: true,
    dataCyClassName: 'Usage-TVEpisodeTableColumn-totalViewsMin',
  },
  {
    name: 'Avg view minutes',
    key: 'avg_view_minutes',
    size: 'small',
    className: styles.colWidth,
    sortable: true,
    dataCyClassName: 'Usage-TVEpisodeTableColumn-avgViewmin',
  },
];

const data = [
  {
    rank: '1',
    channel: 'TELEMUNDO',
    passengers: {
      display: '27,608',
      sort: 27608,
    },
    passenger_pool_per: '6.3%',
    total_views_minutes: {
      display: '938,672',
      sort: 938672,
    },
    avg_view_minutes: 34,
  },
  {
    rank: '2',
    channel: 'GOLF',
    passengers: {
      display: '26,424',
      sort: 26424,
    },
    passenger_pool_per: '6.0%',
    total_views_minutes: {
      display: '792,720',
      sort: 792720,
    },
    avg_view_minutes: 30,
  },
  {
    rank: '3',
    channel: 'ESPN',
    passengers: {
      display: '22,592',
      sort: 22592,
    },
    passenger_pool_per: '5.1%',
    total_views_minutes: {
      display: '858,496',
      sort: 858496,
    },
    avg_view_minutes: 38,
  },
  {
    rank: '4',
    channel: 'CNBC',
    passengers: {
      display: '20,904',
      sort: 20904,
    },
    passenger_pool_per: '4.7%',
    total_views_minutes: {
      display: '794,352',
      sort: 794352,
    },
    avg_view_minutes: 38,
  },
  {
    rank: '5',
    channel: 'FOX',
    passengers: {
      display: '20,680',
      sort: 20680,
    },
    passenger_pool_per: '4.7%',
    total_views_minutes: {
      display: '827,200',
      sort: 827200,
    },
    avg_view_minutes: 40,
  },
];

const LiveTV = () => {
  const [filterData, setFilterData] = useState(data);
  const [filters, setFilters] = useState(defaultUsageFilters);

  useEffect(() => {
    const { searchText } = filters;
    const filteredData = data.filter((obj) => {
      return obj.channel.toLowerCase().startsWith(searchText?.toLowerCase());
    });
    setFilterData(filteredData);
  }, [filters]);

  const week = WeekOptions[filters.week];
  const options = { month: 'short', day: 'numeric' };

  return (
    <Row className={styles.root} noGutters>
      <Col>
        <Row className={styles.title} noGutters>
          <Col data-cy-id="Usage-LiveTV-Header" className="title_1">
            Live TV
          </Col>
        </Row>
        <Row noGutters>
          <UsageFilter
            onFilterClick={(filters) => {
              setFilters(filters);
            }}
            onClear={(filters) => {
              setFilters(filters);
            }}
          />
        </Row>
        <Row className={styles.dataContainer} noGutters>
          <Col className="h-100">
            <Row className={styles.tableContainer} noGutters>
              <Col className="h-100">
                <SkyPulseTable
                  columns={columnDefinitions}
                  rows={filterData}
                  title={
                    <Row>
                      <Col>
                        {filters.option === 'week'
                          ? `Week of:
                          ${new Date(week?.startDt).toLocaleDateString(
                            'en-US',
                            options,
                          )}
                          -
                          ${new Date(week?.endDt).toLocaleDateString(
                            'en-US',
                            options,
                          )}
                          , ${new Date(week?.endDt).getFullYear()}`
                          : `Starting ${getUTCShortDate(
                              filters.startingDt,
                            )}, for ${filters.noOfDays} ${
                              filters.noOfDays === 1 ? 'day' : 'days'
                            }`}
                      </Col>
                      <Col md="auto">
                        Pool: <b>500,145</b> passengers used system
                      </Col>
                    </Row>
                  }
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default LiveTV;
